export default __webpack_public_path__ + "static/media/Rod Vilhauer.cd5053f4.jpg";